import * as _ from "lodash";
import * as React from "react";
import * as ReactBootstrap from "react-bootstrap";
var Fade = ReactBootstrap.Fade;
export class NotificationMessageNotifier extends React.Component {
    constructor(props) {
        super(props);
        this.messageKey = "notification/lastMessages";
        this.getMessagesToUpdate = () => {
            if (!this.state.messages || this.state.messages.length < 1) {
                return [];
            }
            return JSON.parse(JSON.stringify(this.state.messages));
        };
        this.handleDismiss = (id) => {
            const updatedMessages = this.getMessagesToUpdate();
            const message = updatedMessages.find((msg) => msg.id === id);
            if (message) {
                message.viewed = true;
            }
            this.updateLocalStorage(updatedMessages);
            this.setState({
                messages: updatedMessages
            });
        };
        this.toggleMessage = () => {
            const updatedMessages = this.getMessagesToUpdate();
            const someMessagesShown = updatedMessages.some((msg) => !msg.viewed);
            const toggledViewStatus = someMessagesShown;
            const messagesWithViewStatus = updatedMessages.map((msg) => { msg.viewed = toggledViewStatus; return msg; });
            this.updateLocalStorage(messagesWithViewStatus);
            this.setState({
                messages: messagesWithViewStatus
            });
        };
        this.state = {
            messages: []
        };
    }
    componentDidMount() {
        fetch("api/navigation/notification", { credentials: "same-origin" }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    const messages = this.updateViewedStatusFromLocalStorage(result) || [];
                    this.setState({
                        messages: messages
                    });
                }).catch((err) => Promise.reject(err));
            }
            else {
                response.json().then((err) => Promise.reject(err));
            }
        }).catch((err) => console.error("Unable to retrive notification message: " + err));
    }
    render() {
        if (this.state.messages == null || this.state.messages.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: this.props.className },
            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                React.createElement("li", null,
                    React.createElement("p", { className: "navbar-text pointer " },
                        React.createElement("span", { className: "glyphicon glyphicon-warning-sign state-color-started", onClick: this.toggleMessage })))),
            React.createElement("div", { className: "clear notification-alert-container" }, _.map(this.state.messages, (message) => React.createElement(NotificationMessageViewer, { key: message.id, message: message.message, viewed: message.viewed, messageId: message.id, onDismiss: this.handleDismiss })))));
    }
    updateViewedStatusFromLocalStorage(messages) {
        if (typeof (Storage) !== "undefined") {
            const localStoreMessages = JSON.parse(localStorage.getItem(this.messageKey)) || [];
            const updatedMessages = (messages || []).map((msg) => {
                const localMessage = localStoreMessages.find((lmsg) => lmsg.id === msg.id);
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }
                return msg;
            });
            return updatedMessages;
        }
    }
    updateLocalStorage(messages) {
        if (typeof (Storage) !== "undefined") {
            const messageStatuses = (messages || []).map((msg) => ({ id: msg.id, viewed: msg.viewed }));
            localStorage.setItem(this.messageKey, JSON.stringify(messageStatuses));
        }
    }
}
export class NotificationMessageViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.handleDismissClick = () => {
            this.props.onDismiss(this.props.messageId);
        };
    }
    render() {
        return (React.createElement(Fade, { in: !this.props.viewed, unmountOnExit: true },
            React.createElement("div", { className: "clear" },
                React.createElement("div", { className: "alert alert-warning notification-alert" },
                    React.createElement("span", { className: "close", onClick: this.handleDismissClick }, "\u00D7"),
                    React.createElement("p", null, this.props.message)))));
    }
}
